import {Component, Input} from '@angular/core';
import {Quiz} from './types/quiz';

@Component({
    selector: 'app-question-preview',
    templateUrl: './question-preview.component.html',
    styleUrls: ['./question-preview.component.scss'],
    standalone: false
})
export class QuestionPreviewComponent {
    @Input({required: true})
    public questionPreview!: Quiz;

    @Input()
    public type: 'full' | 'basic' = 'basic';

    public selectedAvailableTags: string[] = [];
    public availableTags: string[] = [];

}
